import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
import * as dcei_wildsky_common_proto from './dcei_wildsky_common_proto';
export class Level {
  get descriptor() {
    return Level.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasDifficulty = false;
    this._difficulty = null;
    this._hasPlayerLevelMin = false;
    this._playerLevelMin = null;
    this._hasPlayerLevelMax = false;
    this._playerLevelMax = null;
    this._rewardPattern = [];
    this._hasDisplayImage = false;
    this._displayImage = null;
    this._mapKeys = [];
  }
  isEmpty() {
    if (this._hasDifficulty) return false;
    if (this._hasPlayerLevelMin) return false;
    if (this._hasPlayerLevelMax) return false;
    if (this._rewardPattern.length > 0) return false;
    if (this._hasDisplayImage) return false;
    if (this._mapKeys.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Level) {
      return value;
    }
    return Level.fromJson(value);
  }
  static fromJson(json) {
    const result = new Level();
    if (json.difficulty != null) {
      result._hasDifficulty = true;
      result._difficulty = JsonToInt32.fromJson(json.difficulty);
    }
    if (json.playerLevelMin != null) {
      result._hasPlayerLevelMin = true;
      result._playerLevelMin = JsonToInt32.fromJson(json.playerLevelMin);
    }
    if (json.playerLevelMax != null) {
      result._hasPlayerLevelMax = true;
      result._playerLevelMax = JsonToInt32.fromJson(json.playerLevelMax);
    }
    result._rewardPattern = JsonToList(json.rewardPattern, JsonToString);
    if (json.displayImage != null) {
      result._hasDisplayImage = true;
      result._displayImage = JsonToString.fromJson(json.displayImage);
    }
    result._mapKeys = JsonToList(json.mapKeys, JsonToString);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasDifficulty) {
      result.difficulty = JsonToInt32.toJson(this._difficulty);
    }
    if (this._hasPlayerLevelMin) {
      result.playerLevelMin = JsonToInt32.toJson(this._playerLevelMin);
    }
    if (this._hasPlayerLevelMax) {
      result.playerLevelMax = JsonToInt32.toJson(this._playerLevelMax);
    }
    if (this._rewardPattern.length > 0) {
      result.rewardPattern = ArrayToJson(this._rewardPattern, JsonToString);
    }
    if (this._hasDisplayImage) {
      result.displayImage = JsonToString.toJson(this._displayImage);
    }
    if (this._mapKeys.length > 0) {
      result.mapKeys = ArrayToJson(this._mapKeys, JsonToString);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get difficulty() {
    return this._hasDifficulty ? this._difficulty : JsonToInt32.default;
  }
  get hasDifficulty() {
    return this._hasDifficulty;
  }
  setDifficulty(path, value) {
    return {type: 'SET', path: path.concat(['difficulty']), value};
  }
  deleteDifficulty(path) {
    return {type: 'DELETE', path: path.concat(['difficulty'])};
  }
  /**
   * @returns {number}
   */
  get playerLevelMin() {
    return this._hasPlayerLevelMin ? this._playerLevelMin : JsonToInt32.default;
  }
  get hasPlayerLevelMin() {
    return this._hasPlayerLevelMin;
  }
  setPlayerLevelMin(path, value) {
    return {type: 'SET', path: path.concat(['playerLevelMin']), value};
  }
  deletePlayerLevelMin(path) {
    return {type: 'DELETE', path: path.concat(['playerLevelMin'])};
  }
  /**
   * @returns {number}
   */
  get playerLevelMax() {
    return this._hasPlayerLevelMax ? this._playerLevelMax : JsonToInt32.default;
  }
  get hasPlayerLevelMax() {
    return this._hasPlayerLevelMax;
  }
  setPlayerLevelMax(path, value) {
    return {type: 'SET', path: path.concat(['playerLevelMax']), value};
  }
  deletePlayerLevelMax(path) {
    return {type: 'DELETE', path: path.concat(['playerLevelMax'])};
  }
  /**
   * @returns {string[]}
   */
  get rewardPattern() {
    return this._rewardPattern;
  }
  addRewardPattern(path, value) {
    return {type: 'ADD', path: path.concat(['rewardPattern']), value};
  }
  setRewardPattern(path, value) {
    return {type: 'SET', path: path.concat(['rewardPattern']), value: ArrayToJson(value, JsonToString)};
  }
  setRewardPatternByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['rewardPattern', key]), value};
  }
  deleteRewardPattern(path) {
    return {type: 'DELETE', path: path.concat(['rewardPattern'])};
  }
  deleteRewardPatternByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['rewardPattern', key])};
  }
  /**
   * @returns {string}
   */
  get displayImage() {
    return this._hasDisplayImage ? this._displayImage : JsonToString.default;
  }
  get hasDisplayImage() {
    return this._hasDisplayImage;
  }
  setDisplayImage(path, value) {
    return {type: 'SET', path: path.concat(['displayImage']), value};
  }
  deleteDisplayImage(path) {
    return {type: 'DELETE', path: path.concat(['displayImage'])};
  }
  /**
   * @returns {string[]}
   */
  get mapKeys() {
    return this._mapKeys;
  }
  addMapKeys(path, value) {
    return {type: 'ADD', path: path.concat(['mapKeys']), value};
  }
  setMapKeys(path, value) {
    return {type: 'SET', path: path.concat(['mapKeys']), value: ArrayToJson(value, JsonToString)};
  }
  setMapKeysByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['mapKeys', key]), value};
  }
  deleteMapKeys(path) {
    return {type: 'DELETE', path: path.concat(['mapKeys'])};
  }
  deleteMapKeysByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['mapKeys', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "difficulty": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Level(this);
              copy._hasDifficulty = true;
              copy._difficulty = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDifficulty) {
                return this;
              }
              const copy = new Level(this);
              copy._hasDifficulty = false;
              copy._difficulty = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "playerLevelMin": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Level(this);
              copy._hasPlayerLevelMin = true;
              copy._playerLevelMin = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPlayerLevelMin) {
                return this;
              }
              const copy = new Level(this);
              copy._hasPlayerLevelMin = false;
              copy._playerLevelMin = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "playerLevelMax": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Level(this);
              copy._hasPlayerLevelMax = true;
              copy._playerLevelMax = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPlayerLevelMax) {
                return this;
              }
              const copy = new Level(this);
              copy._hasPlayerLevelMax = false;
              copy._playerLevelMax = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "rewardPattern": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Level(this);
              copy._rewardPattern = [];        for (let i of value) {
                copy._rewardPattern.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Level(this);
              copy._rewardPattern = copy._rewardPattern.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._rewardPattern.length === 0) {
                return this;
              }
              const copy = new Level(this);
              copy._rewardPattern = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._rewardPattern.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Level(this);
              copy._rewardPattern = copy._rewardPattern.slice();
              copy._rewardPattern[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Level(this);
              copy._rewardPattern = copy._rewardPattern.slice(0, path[1]).concat(copy._rewardPattern.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._rewardPattern.length) {
            return this;
          }
          const oldValue = this._rewardPattern[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Level(this);
          copy._rewardPattern = copy._rewardPattern.slice();
          copy._rewardPattern[key] = newValue;
          return copy;
        }
      }
      case "displayImage": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Level(this);
              copy._hasDisplayImage = true;
              copy._displayImage = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplayImage) {
                return this;
              }
              const copy = new Level(this);
              copy._hasDisplayImage = false;
              copy._displayImage = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "mapKeys": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Level(this);
              copy._mapKeys = [];        for (let i of value) {
                copy._mapKeys.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Level(this);
              copy._mapKeys = copy._mapKeys.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._mapKeys.length === 0) {
                return this;
              }
              const copy = new Level(this);
              copy._mapKeys = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._mapKeys.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Level(this);
              copy._mapKeys = copy._mapKeys.slice();
              copy._mapKeys[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Level(this);
              copy._mapKeys = copy._mapKeys.slice(0, path[1]).concat(copy._mapKeys.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._mapKeys.length) {
            return this;
          }
          const oldValue = this._mapKeys[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Level(this);
          copy._mapKeys = copy._mapKeys.slice();
          copy._mapKeys[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Level} other
   * @returns {Level}
   */
  merge(other) {
    const copy = new Level(this);
    if (other._hasDifficulty) {
      copy._hasDifficulty = true;
      copy._difficulty = other._difficulty;
    }
    if (other._hasPlayerLevelMin) {
      copy._hasPlayerLevelMin = true;
      copy._playerLevelMin = other._playerLevelMin;
    }
    if (other._hasPlayerLevelMax) {
      copy._hasPlayerLevelMax = true;
      copy._playerLevelMax = other._playerLevelMax;
    }
    copy._rewardPattern = this._rewardPattern.concat(other._rewardPattern);
    if (other._hasDisplayImage) {
      copy._hasDisplayImage = true;
      copy._displayImage = other._displayImage;
    }
    copy._mapKeys = this._mapKeys.concat(other._mapKeys);
    return copy;
  }
}
Level.default = new Level();
class Level_Builder {
  constructor(value) {
    this._value = new Level(value);
  }
  build() {
    return new Level(this._value);
  }
  setDifficulty(value) {
    this._value._hasDifficulty = true;
    this._value._difficulty = value;
    return this;
  }
  deleteDifficulty() {
    this._value._hasDifficulty = false;
    this._value._difficulty = null;
    return this;
  }
  setPlayerLevelMin(value) {
    this._value._hasPlayerLevelMin = true;
    this._value._playerLevelMin = value;
    return this;
  }
  deletePlayerLevelMin() {
    this._value._hasPlayerLevelMin = false;
    this._value._playerLevelMin = null;
    return this;
  }
  setPlayerLevelMax(value) {
    this._value._hasPlayerLevelMax = true;
    this._value._playerLevelMax = value;
    return this;
  }
  deletePlayerLevelMax() {
    this._value._hasPlayerLevelMax = false;
    this._value._playerLevelMax = null;
    return this;
  }
  addAllRewardPattern(values) {
    this._value._rewardPattern = this._value._rewardPattern.concat(values);
    return this;
  }
  addRewardPattern(value) {
    this._value._rewardPattern = this._value._rewardPattern.concat([value]);
    return this;
  }
  setRewardPattern(index, value) {
    this._value._rewardPattern = this._value._rewardPattern.concat();
    this._value._rewardPattern[index] = value;
    return this;
  }
  clearRewardPattern() {
    this._value._rewardPattern = [];
    return this;
  }
  setDisplayImage(value) {
    this._value._hasDisplayImage = true;
    this._value._displayImage = value;
    return this;
  }
  deleteDisplayImage() {
    this._value._hasDisplayImage = false;
    this._value._displayImage = null;
    return this;
  }
  addAllMapKeys(values) {
    this._value._mapKeys = this._value._mapKeys.concat(values);
    return this;
  }
  addMapKeys(value) {
    this._value._mapKeys = this._value._mapKeys.concat([value]);
    return this;
  }
  setMapKeys(index, value) {
    this._value._mapKeys = this._value._mapKeys.concat();
    this._value._mapKeys[index] = value;
    return this;
  }
  clearMapKeys() {
    this._value._mapKeys = [];
    return this;
  }
}
Level.Builder = Level_Builder;
class Level_WithParent {
  /**
   * @param {Level} value
   * @param {Level_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Level.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasDifficulty() {
    if (this._cachedHasDifficulty === undefined) {
      if (this._value.hasDifficulty) {
        this._cachedHasDifficulty = true;
      } else {
        this._cachedHasDifficulty = this._parent ? this._parent.hasDifficulty : false;
      }
    }
    return this._cachedHasDifficulty;
  }
  get difficulty() {
    if (this._cachedDifficulty === undefined) {
      if (this._value.hasDifficulty) {
        this._cachedDifficulty = this._value.difficulty;
      } else {
        this._cachedDifficulty = this._parent ? this._parent.difficulty : this._value.difficulty;
      }
    }
    return this._cachedDifficulty;
  }
  get hasPlayerLevelMin() {
    if (this._cachedHasPlayerLevelMin === undefined) {
      if (this._value.hasPlayerLevelMin) {
        this._cachedHasPlayerLevelMin = true;
      } else {
        this._cachedHasPlayerLevelMin = this._parent ? this._parent.hasPlayerLevelMin : false;
      }
    }
    return this._cachedHasPlayerLevelMin;
  }
  get playerLevelMin() {
    if (this._cachedPlayerLevelMin === undefined) {
      if (this._value.hasPlayerLevelMin) {
        this._cachedPlayerLevelMin = this._value.playerLevelMin;
      } else {
        this._cachedPlayerLevelMin = this._parent ? this._parent.playerLevelMin : this._value.playerLevelMin;
      }
    }
    return this._cachedPlayerLevelMin;
  }
  get hasPlayerLevelMax() {
    if (this._cachedHasPlayerLevelMax === undefined) {
      if (this._value.hasPlayerLevelMax) {
        this._cachedHasPlayerLevelMax = true;
      } else {
        this._cachedHasPlayerLevelMax = this._parent ? this._parent.hasPlayerLevelMax : false;
      }
    }
    return this._cachedHasPlayerLevelMax;
  }
  get playerLevelMax() {
    if (this._cachedPlayerLevelMax === undefined) {
      if (this._value.hasPlayerLevelMax) {
        this._cachedPlayerLevelMax = this._value.playerLevelMax;
      } else {
        this._cachedPlayerLevelMax = this._parent ? this._parent.playerLevelMax : this._value.playerLevelMax;
      }
    }
    return this._cachedPlayerLevelMax;
  }
  get selfRewardPattern() {
    return this._value.rewardPattern;
  }
  get inherentRewardPattern() {
    if (!this._inherentRewardPattern) {
      this._inherentRewardPattern = this._parent ? this._parent.rewardPattern : [];
    }
    return this._inherentRewardPattern;
  }
  get rewardPattern() {
    if (!this._allRewardPattern) {
      this._allRewardPattern = this._parent ? this._parent.rewardPattern.concat(this.selfRewardPattern) : this.selfRewardPattern;
    }
    return this._allRewardPattern;
  }
  get hasDisplayImage() {
    if (this._cachedHasDisplayImage === undefined) {
      if (this._value.hasDisplayImage) {
        this._cachedHasDisplayImage = true;
      } else {
        this._cachedHasDisplayImage = this._parent ? this._parent.hasDisplayImage : false;
      }
    }
    return this._cachedHasDisplayImage;
  }
  get displayImage() {
    if (this._cachedDisplayImage === undefined) {
      if (this._value.hasDisplayImage) {
        this._cachedDisplayImage = this._value.displayImage;
      } else {
        this._cachedDisplayImage = this._parent ? this._parent.displayImage : this._value.displayImage;
      }
    }
    return this._cachedDisplayImage;
  }
  get selfMapKeys() {
    return this._value.mapKeys;
  }
  get inherentMapKeys() {
    if (!this._inherentMapKeys) {
      this._inherentMapKeys = this._parent ? this._parent.mapKeys : [];
    }
    return this._inherentMapKeys;
  }
  get mapKeys() {
    if (!this._allMapKeys) {
      this._allMapKeys = this._parent ? this._parent.mapKeys.concat(this.selfMapKeys) : this.selfMapKeys;
    }
    return this._allMapKeys;
  }
  update(current, parent) {
    const result = new Level_WithParent(current, parent);
    return result;
  }
}
Level_WithParent.default = new Level_WithParent(Level.default, null);
Level.WithParent = Level_WithParent;
class Level_Descriptor {
  get difficulty() {
    if (!this._difficulty) {
      this._difficulty = {
        name: "difficulty",
        Name: "Difficulty",
        number: 1,
        protoType: 5,
        protoName: "difficulty",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._difficulty;
  }
  get playerLevelMin() {
    if (!this._playerLevelMin) {
      this._playerLevelMin = {
        name: "playerLevelMin",
        Name: "PlayerLevelMin",
        number: 2,
        protoType: 5,
        protoName: "player_level_min",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._playerLevelMin;
  }
  get playerLevelMax() {
    if (!this._playerLevelMax) {
      this._playerLevelMax = {
        name: "playerLevelMax",
        Name: "PlayerLevelMax",
        number: 3,
        protoType: 5,
        protoName: "player_level_max",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._playerLevelMax;
  }
  get rewardPattern() {
    if (!this._rewardPattern) {
      this._rewardPattern = {
        name: "rewardPattern",
        Name: "RewardPattern",
        number: 5,
        protoType: 9,
        protoName: "reward_pattern",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "RewardPatternKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rewardPattern;
  }
  get displayImage() {
    if (!this._displayImage) {
      this._displayImage = {
        name: "displayImage",
        Name: "DisplayImage",
        number: 6,
        protoType: 9,
        protoName: "display_image",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displayImage;
  }
  get mapKeys() {
    if (!this._mapKeys) {
      this._mapKeys = {
        name: "mapKeys",
        Name: "MapKeys",
        number: 10,
        protoType: 9,
        protoName: "map_keys",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "MapKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._mapKeys;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.difficulty,
        this.playerLevelMin,
        this.playerLevelMax,
        this.rewardPattern,
        this.displayImage,
        this.mapKeys,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDifficulty",
        Name: "DummyOneofForDifficulty",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPlayerLevelMin",
        Name: "DummyOneofForPlayerLevelMin",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPlayerLevelMax",
        Name: "DummyOneofForPlayerLevelMax",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisplayImage",
        Name: "DummyOneofForDisplayImage",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
Level.descriptor = new Level_Descriptor();
export class Dungeon {
  get descriptor() {
    return Dungeon.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasDungeonIndex = false;
    this._dungeonIndex = null;
    this._hasDisplayName = false;
    this._displayName = null;
    this._openDays = [];
    this._levels = [];
    this._hasSideImage = false;
    this._sideImage = null;
  }
  isEmpty() {
    if (this._hasDungeonIndex) return false;
    if (this._hasDisplayName) return false;
    if (this._openDays.length > 0) return false;
    if (this._levels.length > 0) return false;
    if (this._hasSideImage) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Dungeon) {
      return value;
    }
    return Dungeon.fromJson(value);
  }
  static fromJson(json) {
    const result = new Dungeon();
    if (json.dungeonIndex != null) {
      result._hasDungeonIndex = true;
      result._dungeonIndex = JsonToInt32.fromJson(json.dungeonIndex);
    }
    if (json.displayName != null) {
      result._hasDisplayName = true;
      result._displayName = JsonToString.fromJson(json.displayName);
    }
    result._openDays = JsonToList(json.openDays, JsonToString);
    result._levels = JsonToList(json.levels, Level);
    if (json.sideImage != null) {
      result._hasSideImage = true;
      result._sideImage = JsonToString.fromJson(json.sideImage);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasDungeonIndex) {
      result.dungeonIndex = JsonToInt32.toJson(this._dungeonIndex);
    }
    if (this._hasDisplayName) {
      result.displayName = JsonToString.toJson(this._displayName);
    }
    if (this._openDays.length > 0) {
      result.openDays = ArrayToJson(this._openDays, JsonToString);
    }
    if (this._levels.length > 0) {
      result.levels = ArrayToJson(this._levels, Level);
    }
    if (this._hasSideImage) {
      result.sideImage = JsonToString.toJson(this._sideImage);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get dungeonIndex() {
    return this._hasDungeonIndex ? this._dungeonIndex : JsonToInt32.default;
  }
  get hasDungeonIndex() {
    return this._hasDungeonIndex;
  }
  setDungeonIndex(path, value) {
    return {type: 'SET', path: path.concat(['dungeonIndex']), value};
  }
  deleteDungeonIndex(path) {
    return {type: 'DELETE', path: path.concat(['dungeonIndex'])};
  }
  /**
   * @returns {string}
   */
  get displayName() {
    return this._hasDisplayName ? this._displayName : JsonToString.default;
  }
  get hasDisplayName() {
    return this._hasDisplayName;
  }
  setDisplayName(path, value) {
    return {type: 'SET', path: path.concat(['displayName']), value};
  }
  deleteDisplayName(path) {
    return {type: 'DELETE', path: path.concat(['displayName'])};
  }
  /**
   * @returns {string[]}
   */
  get openDays() {
    return this._openDays;
  }
  addOpenDays(path, value) {
    return {type: 'ADD', path: path.concat(['openDays']), value};
  }
  setOpenDays(path, value) {
    return {type: 'SET', path: path.concat(['openDays']), value: ArrayToJson(value, JsonToString)};
  }
  setOpenDaysByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['openDays', key]), value};
  }
  deleteOpenDays(path) {
    return {type: 'DELETE', path: path.concat(['openDays'])};
  }
  deleteOpenDaysByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['openDays', key])};
  }
  /**
   * @returns {Level[]}
   */
  get levels() {
    return this._levels;
  }
  addLevels(path, value) {
    return {type: 'ADD', path: path.concat(['levels']), value: value.toJson()};
  }
  setLevels(path, value) {
    return {type: 'SET', path: path.concat(['levels']), value: ArrayToJson(value, Level)};
  }
  setLevelsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['levels', key]), value: value.toJson()};
  }
  deleteLevels(path) {
    return {type: 'DELETE', path: path.concat(['levels'])};
  }
  deleteLevelsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['levels', key])};
  }
  /**
   * @returns {string}
   */
  get sideImage() {
    return this._hasSideImage ? this._sideImage : JsonToString.default;
  }
  get hasSideImage() {
    return this._hasSideImage;
  }
  setSideImage(path, value) {
    return {type: 'SET', path: path.concat(['sideImage']), value};
  }
  deleteSideImage(path) {
    return {type: 'DELETE', path: path.concat(['sideImage'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "dungeonIndex": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Dungeon(this);
              copy._hasDungeonIndex = true;
              copy._dungeonIndex = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDungeonIndex) {
                return this;
              }
              const copy = new Dungeon(this);
              copy._hasDungeonIndex = false;
              copy._dungeonIndex = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "displayName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Dungeon(this);
              copy._hasDisplayName = true;
              copy._displayName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplayName) {
                return this;
              }
              const copy = new Dungeon(this);
              copy._hasDisplayName = false;
              copy._displayName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "openDays": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Dungeon(this);
              copy._openDays = [];        for (let i of value) {
                copy._openDays.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Dungeon(this);
              copy._openDays = copy._openDays.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._openDays.length === 0) {
                return this;
              }
              const copy = new Dungeon(this);
              copy._openDays = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._openDays.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Dungeon(this);
              copy._openDays = copy._openDays.slice();
              copy._openDays[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Dungeon(this);
              copy._openDays = copy._openDays.slice(0, path[1]).concat(copy._openDays.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._openDays.length) {
            return this;
          }
          const oldValue = this._openDays[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Dungeon(this);
          copy._openDays = copy._openDays.slice();
          copy._openDays[key] = newValue;
          return copy;
        }
      }
      case "levels": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Dungeon(this);
              copy._levels = [];        for (let i of value) {
                copy._levels.push(Level.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Dungeon(this);
              copy._levels = copy._levels.concat([Level.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._levels.length === 0) {
                return this;
              }
              const copy = new Dungeon(this);
              copy._levels = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._levels.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Dungeon(this);
              copy._levels = copy._levels.slice();
              copy._levels[path[1]] = Level.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Dungeon(this);
              copy._levels = copy._levels.slice(0, path[1]).concat(copy._levels.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._levels.length) {
            return this;
          }
          const oldValue = this._levels[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Dungeon(this);
          copy._levels = copy._levels.slice();
          copy._levels[key] = newValue;
          return copy;
        }
      }
      case "sideImage": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Dungeon(this);
              copy._hasSideImage = true;
              copy._sideImage = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSideImage) {
                return this;
              }
              const copy = new Dungeon(this);
              copy._hasSideImage = false;
              copy._sideImage = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Dungeon} other
   * @returns {Dungeon}
   */
  merge(other) {
    const copy = new Dungeon(this);
    if (other._hasDungeonIndex) {
      copy._hasDungeonIndex = true;
      copy._dungeonIndex = other._dungeonIndex;
    }
    if (other._hasDisplayName) {
      copy._hasDisplayName = true;
      copy._displayName = other._displayName;
    }
    copy._openDays = this._openDays.concat(other._openDays);
    copy._levels = this._levels.concat(other._levels);
    if (other._hasSideImage) {
      copy._hasSideImage = true;
      copy._sideImage = other._sideImage;
    }
    return copy;
  }
}
Dungeon.default = new Dungeon();
class Dungeon_Builder {
  constructor(value) {
    this._value = new Dungeon(value);
  }
  build() {
    return new Dungeon(this._value);
  }
  setDungeonIndex(value) {
    this._value._hasDungeonIndex = true;
    this._value._dungeonIndex = value;
    return this;
  }
  deleteDungeonIndex() {
    this._value._hasDungeonIndex = false;
    this._value._dungeonIndex = null;
    return this;
  }
  setDisplayName(value) {
    this._value._hasDisplayName = true;
    this._value._displayName = value;
    return this;
  }
  deleteDisplayName() {
    this._value._hasDisplayName = false;
    this._value._displayName = null;
    return this;
  }
  addAllOpenDays(values) {
    this._value._openDays = this._value._openDays.concat(values);
    return this;
  }
  addOpenDays(value) {
    this._value._openDays = this._value._openDays.concat([value]);
    return this;
  }
  setOpenDays(index, value) {
    this._value._openDays = this._value._openDays.concat();
    this._value._openDays[index] = value;
    return this;
  }
  clearOpenDays() {
    this._value._openDays = [];
    return this;
  }
  addAllLevels(values) {
    this._value._levels = this._value._levels.concat(values);
    return this;
  }
  addLevels(value) {
    this._value._levels = this._value._levels.concat([value]);
    return this;
  }
  setLevels(index, value) {
    this._value._levels = this._value._levels.concat();
    this._value._levels[index] = value;
    return this;
  }
  clearLevels() {
    this._value._levels = [];
    return this;
  }
  setSideImage(value) {
    this._value._hasSideImage = true;
    this._value._sideImage = value;
    return this;
  }
  deleteSideImage() {
    this._value._hasSideImage = false;
    this._value._sideImage = null;
    return this;
  }
}
Dungeon.Builder = Dungeon_Builder;
class Dungeon_WithParent {
  /**
   * @param {Dungeon} value
   * @param {Dungeon_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Dungeon.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasDungeonIndex() {
    if (this._cachedHasDungeonIndex === undefined) {
      if (this._value.hasDungeonIndex) {
        this._cachedHasDungeonIndex = true;
      } else {
        this._cachedHasDungeonIndex = this._parent ? this._parent.hasDungeonIndex : false;
      }
    }
    return this._cachedHasDungeonIndex;
  }
  get dungeonIndex() {
    if (this._cachedDungeonIndex === undefined) {
      if (this._value.hasDungeonIndex) {
        this._cachedDungeonIndex = this._value.dungeonIndex;
      } else {
        this._cachedDungeonIndex = this._parent ? this._parent.dungeonIndex : this._value.dungeonIndex;
      }
    }
    return this._cachedDungeonIndex;
  }
  get hasDisplayName() {
    if (this._cachedHasDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedHasDisplayName = true;
      } else {
        this._cachedHasDisplayName = this._parent ? this._parent.hasDisplayName : false;
      }
    }
    return this._cachedHasDisplayName;
  }
  get displayName() {
    if (this._cachedDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedDisplayName = this._value.displayName;
      } else {
        this._cachedDisplayName = this._parent ? this._parent.displayName : this._value.displayName;
      }
    }
    return this._cachedDisplayName;
  }
  get selfOpenDays() {
    return this._value.openDays;
  }
  get inherentOpenDays() {
    if (!this._inherentOpenDays) {
      this._inherentOpenDays = this._parent ? this._parent.openDays : [];
    }
    return this._inherentOpenDays;
  }
  get openDays() {
    if (!this._allOpenDays) {
      this._allOpenDays = this._parent ? this._parent.openDays.concat(this.selfOpenDays) : this.selfOpenDays;
    }
    return this._allOpenDays;
  }
  get selfLevels() {
    if (!this._selfLevels) {
      this._selfLevels = [];
      for (let i of this._value.levels) {
        this._selfLevels.push(new Level.WithParent(i, null));
      }
    }
    return this._selfLevels;
  }
  get inherentLevels() {
    if (!this._inherentLevels) {
      this._inherentLevels = this._parent ? this._parent.levels : [];
    }
    return this._inherentLevels;
  }
  get levels() {
    if (!this._allLevels) {
      this._allLevels = this._parent ? this._parent.levels.concat(this.selfLevels) : this.selfLevels;
    }
    return this._allLevels;
  }
  get hasSideImage() {
    if (this._cachedHasSideImage === undefined) {
      if (this._value.hasSideImage) {
        this._cachedHasSideImage = true;
      } else {
        this._cachedHasSideImage = this._parent ? this._parent.hasSideImage : false;
      }
    }
    return this._cachedHasSideImage;
  }
  get sideImage() {
    if (this._cachedSideImage === undefined) {
      if (this._value.hasSideImage) {
        this._cachedSideImage = this._value.sideImage;
      } else {
        this._cachedSideImage = this._parent ? this._parent.sideImage : this._value.sideImage;
      }
    }
    return this._cachedSideImage;
  }
  update(current, parent) {
    const result = new Dungeon_WithParent(current, parent);
    if (this._selfLevels) {
      if (this._value.levels === current.levels) {
        result._selfLevels = this._selfLevels;
      } else {
        result._selfLevels = [];
        for (let i = 0; i < current.levels.length; i++) {
          const oldValue = this._value.levels[i];
          if (oldValue) {
            const oldCache = this._selfLevels[i];
            if (oldValue === current.levels[i]) {
              result._selfLevels[i] = oldCache;
            } else {
              result._selfLevels[i] = oldCache.update(current.levels[i], null);
            }
          } else {
            result._selfLevels[i] = new Level.WithParent(current.levels[i], null);
          }
        }
      }
    }
    return result;
  }
}
Dungeon_WithParent.default = new Dungeon_WithParent(Dungeon.default, null);
Dungeon.WithParent = Dungeon_WithParent;
class Dungeon_Descriptor {
  get dungeonIndex() {
    if (!this._dungeonIndex) {
      this._dungeonIndex = {
        name: "dungeonIndex",
        Name: "DungeonIndex",
        number: 1,
        protoType: 5,
        protoName: "dungeon_index",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dungeonIndex;
  }
  get displayName() {
    if (!this._displayName) {
      this._displayName = {
        name: "displayName",
        Name: "DisplayName",
        number: 2,
        protoType: 9,
        protoName: "display_name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displayName;
  }
  get openDays() {
    if (!this._openDays) {
      this._openDays = {
        name: "openDays",
        Name: "OpenDays",
        number: 3,
        protoType: 9,
        protoName: "open_days",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "DailyQuestOpenDaysStringList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._openDays;
  }
  get levels() {
    if (!this._levels) {
      this._levels = {
        name: "levels",
        Name: "Levels",
        number: 4,
        protoType: 11,
        protoName: "levels",
        type: Level,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._levels;
  }
  get sideImage() {
    if (!this._sideImage) {
      this._sideImage = {
        name: "sideImage",
        Name: "SideImage",
        number: 5,
        protoType: 9,
        protoName: "side_image",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._sideImage;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.dungeonIndex,
        this.displayName,
        this.openDays,
        this.levels,
        this.sideImage,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDungeonIndex",
        Name: "DummyOneofForDungeonIndex",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisplayName",
        Name: "DummyOneofForDisplayName",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSideImage",
        Name: "DummyOneofForSideImage",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
Dungeon.descriptor = new Dungeon_Descriptor();
export class RewardItem {
  get descriptor() {
    return RewardItem.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasItemKey = false;
    this._itemKey = null;
    this._hasAmountMin = false;
    this._amountMin = null;
    this._hasAmountMax = false;
    this._amountMax = null;
    this._hasChance = false;
    this._chance = null;
  }
  isEmpty() {
    if (this._hasItemKey) return false;
    if (this._hasAmountMin) return false;
    if (this._hasAmountMax) return false;
    if (this._hasChance) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof RewardItem) {
      return value;
    }
    return RewardItem.fromJson(value);
  }
  static fromJson(json) {
    const result = new RewardItem();
    if (json.itemKey != null) {
      result._hasItemKey = true;
      result._itemKey = JsonToString.fromJson(json.itemKey);
    }
    if (json.amountMin != null) {
      result._hasAmountMin = true;
      result._amountMin = JsonToInt32.fromJson(json.amountMin);
    }
    if (json.amountMax != null) {
      result._hasAmountMax = true;
      result._amountMax = JsonToInt32.fromJson(json.amountMax);
    }
    if (json.chance != null) {
      result._hasChance = true;
      result._chance = JsonToDouble.fromJson(json.chance);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasItemKey) {
      result.itemKey = JsonToString.toJson(this._itemKey);
    }
    if (this._hasAmountMin) {
      result.amountMin = JsonToInt32.toJson(this._amountMin);
    }
    if (this._hasAmountMax) {
      result.amountMax = JsonToInt32.toJson(this._amountMax);
    }
    if (this._hasChance) {
      result.chance = JsonToDouble.toJson(this._chance);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get itemKey() {
    return this._hasItemKey ? this._itemKey : JsonToString.default;
  }
  get hasItemKey() {
    return this._hasItemKey;
  }
  setItemKey(path, value) {
    return {type: 'SET', path: path.concat(['itemKey']), value};
  }
  deleteItemKey(path) {
    return {type: 'DELETE', path: path.concat(['itemKey'])};
  }
  /**
   * @returns {number}
   */
  get amountMin() {
    return this._hasAmountMin ? this._amountMin : JsonToInt32.default;
  }
  get hasAmountMin() {
    return this._hasAmountMin;
  }
  setAmountMin(path, value) {
    return {type: 'SET', path: path.concat(['amountMin']), value};
  }
  deleteAmountMin(path) {
    return {type: 'DELETE', path: path.concat(['amountMin'])};
  }
  /**
   * @returns {number}
   */
  get amountMax() {
    return this._hasAmountMax ? this._amountMax : JsonToInt32.default;
  }
  get hasAmountMax() {
    return this._hasAmountMax;
  }
  setAmountMax(path, value) {
    return {type: 'SET', path: path.concat(['amountMax']), value};
  }
  deleteAmountMax(path) {
    return {type: 'DELETE', path: path.concat(['amountMax'])};
  }
  /**
   * @returns {number}
   */
  get chance() {
    return this._hasChance ? this._chance : JsonToDouble.default;
  }
  get hasChance() {
    return this._hasChance;
  }
  setChance(path, value) {
    return {type: 'SET', path: path.concat(['chance']), value};
  }
  deleteChance(path) {
    return {type: 'DELETE', path: path.concat(['chance'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "itemKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RewardItem(this);
              copy._hasItemKey = true;
              copy._itemKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasItemKey) {
                return this;
              }
              const copy = new RewardItem(this);
              copy._hasItemKey = false;
              copy._itemKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "amountMin": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RewardItem(this);
              copy._hasAmountMin = true;
              copy._amountMin = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAmountMin) {
                return this;
              }
              const copy = new RewardItem(this);
              copy._hasAmountMin = false;
              copy._amountMin = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "amountMax": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RewardItem(this);
              copy._hasAmountMax = true;
              copy._amountMax = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAmountMax) {
                return this;
              }
              const copy = new RewardItem(this);
              copy._hasAmountMax = false;
              copy._amountMax = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "chance": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RewardItem(this);
              copy._hasChance = true;
              copy._chance = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasChance) {
                return this;
              }
              const copy = new RewardItem(this);
              copy._hasChance = false;
              copy._chance = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {RewardItem} other
   * @returns {RewardItem}
   */
  merge(other) {
    const copy = new RewardItem(this);
    if (other._hasItemKey) {
      copy._hasItemKey = true;
      copy._itemKey = other._itemKey;
    }
    if (other._hasAmountMin) {
      copy._hasAmountMin = true;
      copy._amountMin = other._amountMin;
    }
    if (other._hasAmountMax) {
      copy._hasAmountMax = true;
      copy._amountMax = other._amountMax;
    }
    if (other._hasChance) {
      copy._hasChance = true;
      copy._chance = other._chance;
    }
    return copy;
  }
}
RewardItem.default = new RewardItem();
class RewardItem_Builder {
  constructor(value) {
    this._value = new RewardItem(value);
  }
  build() {
    return new RewardItem(this._value);
  }
  setItemKey(value) {
    this._value._hasItemKey = true;
    this._value._itemKey = value;
    return this;
  }
  deleteItemKey() {
    this._value._hasItemKey = false;
    this._value._itemKey = null;
    return this;
  }
  setAmountMin(value) {
    this._value._hasAmountMin = true;
    this._value._amountMin = value;
    return this;
  }
  deleteAmountMin() {
    this._value._hasAmountMin = false;
    this._value._amountMin = null;
    return this;
  }
  setAmountMax(value) {
    this._value._hasAmountMax = true;
    this._value._amountMax = value;
    return this;
  }
  deleteAmountMax() {
    this._value._hasAmountMax = false;
    this._value._amountMax = null;
    return this;
  }
  setChance(value) {
    this._value._hasChance = true;
    this._value._chance = value;
    return this;
  }
  deleteChance() {
    this._value._hasChance = false;
    this._value._chance = null;
    return this;
  }
}
RewardItem.Builder = RewardItem_Builder;
class RewardItem_WithParent {
  /**
   * @param {RewardItem} value
   * @param {RewardItem_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return RewardItem.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasItemKey() {
    if (this._cachedHasItemKey === undefined) {
      if (this._value.hasItemKey) {
        this._cachedHasItemKey = true;
      } else {
        this._cachedHasItemKey = this._parent ? this._parent.hasItemKey : false;
      }
    }
    return this._cachedHasItemKey;
  }
  get itemKey() {
    if (this._cachedItemKey === undefined) {
      if (this._value.hasItemKey) {
        this._cachedItemKey = this._value.itemKey;
      } else {
        this._cachedItemKey = this._parent ? this._parent.itemKey : this._value.itemKey;
      }
    }
    return this._cachedItemKey;
  }
  get hasAmountMin() {
    if (this._cachedHasAmountMin === undefined) {
      if (this._value.hasAmountMin) {
        this._cachedHasAmountMin = true;
      } else {
        this._cachedHasAmountMin = this._parent ? this._parent.hasAmountMin : false;
      }
    }
    return this._cachedHasAmountMin;
  }
  get amountMin() {
    if (this._cachedAmountMin === undefined) {
      if (this._value.hasAmountMin) {
        this._cachedAmountMin = this._value.amountMin;
      } else {
        this._cachedAmountMin = this._parent ? this._parent.amountMin : this._value.amountMin;
      }
    }
    return this._cachedAmountMin;
  }
  get hasAmountMax() {
    if (this._cachedHasAmountMax === undefined) {
      if (this._value.hasAmountMax) {
        this._cachedHasAmountMax = true;
      } else {
        this._cachedHasAmountMax = this._parent ? this._parent.hasAmountMax : false;
      }
    }
    return this._cachedHasAmountMax;
  }
  get amountMax() {
    if (this._cachedAmountMax === undefined) {
      if (this._value.hasAmountMax) {
        this._cachedAmountMax = this._value.amountMax;
      } else {
        this._cachedAmountMax = this._parent ? this._parent.amountMax : this._value.amountMax;
      }
    }
    return this._cachedAmountMax;
  }
  get hasChance() {
    if (this._cachedHasChance === undefined) {
      if (this._value.hasChance) {
        this._cachedHasChance = true;
      } else {
        this._cachedHasChance = this._parent ? this._parent.hasChance : false;
      }
    }
    return this._cachedHasChance;
  }
  get chance() {
    if (this._cachedChance === undefined) {
      if (this._value.hasChance) {
        this._cachedChance = this._value.chance;
      } else {
        this._cachedChance = this._parent ? this._parent.chance : this._value.chance;
      }
    }
    return this._cachedChance;
  }
  update(current, parent) {
    const result = new RewardItem_WithParent(current, parent);
    return result;
  }
}
RewardItem_WithParent.default = new RewardItem_WithParent(RewardItem.default, null);
RewardItem.WithParent = RewardItem_WithParent;
class RewardItem_Descriptor {
  get itemKey() {
    if (!this._itemKey) {
      this._itemKey = {
        name: "itemKey",
        Name: "ItemKey",
        number: 1,
        protoType: 9,
        protoName: "item_key",
        type: JsonToString,
        options: {
          valueDropdown: "RewardItemKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._itemKey;
  }
  get amountMin() {
    if (!this._amountMin) {
      this._amountMin = {
        name: "amountMin",
        Name: "AmountMin",
        number: 2,
        protoType: 5,
        protoName: "amount_min",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._amountMin;
  }
  get amountMax() {
    if (!this._amountMax) {
      this._amountMax = {
        name: "amountMax",
        Name: "AmountMax",
        number: 3,
        protoType: 5,
        protoName: "amount_max",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._amountMax;
  }
  get chance() {
    if (!this._chance) {
      this._chance = {
        name: "chance",
        Name: "Chance",
        number: 4,
        protoType: 1,
        protoName: "chance",
        type: JsonToDouble,
        options: {
          comments: "For slot, this is treated as weight",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chance;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.itemKey,
        this.amountMin,
        this.amountMax,
        this.chance,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForItemKey",
        Name: "DummyOneofForItemKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAmountMin",
        Name: "DummyOneofForAmountMin",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAmountMax",
        Name: "DummyOneofForAmountMax",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForChance",
        Name: "DummyOneofForChance",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
RewardItem.descriptor = new RewardItem_Descriptor();
export class RewardSlot {
  get descriptor() {
    return RewardSlot.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._slotItems = [];
  }
  isEmpty() {
    if (this._slotItems.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof RewardSlot) {
      return value;
    }
    return RewardSlot.fromJson(value);
  }
  static fromJson(json) {
    const result = new RewardSlot();
    result._slotItems = JsonToList(json.slotItems, RewardItem);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._slotItems.length > 0) {
      result.slotItems = ArrayToJson(this._slotItems, RewardItem);
    }
    return result;
  }
  /**
   * @returns {RewardItem[]}
   */
  get slotItems() {
    return this._slotItems;
  }
  addSlotItems(path, value) {
    return {type: 'ADD', path: path.concat(['slotItems']), value: value.toJson()};
  }
  setSlotItems(path, value) {
    return {type: 'SET', path: path.concat(['slotItems']), value: ArrayToJson(value, RewardItem)};
  }
  setSlotItemsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['slotItems', key]), value: value.toJson()};
  }
  deleteSlotItems(path) {
    return {type: 'DELETE', path: path.concat(['slotItems'])};
  }
  deleteSlotItemsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['slotItems', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "slotItems": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RewardSlot(this);
              copy._slotItems = [];        for (let i of value) {
                copy._slotItems.push(RewardItem.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new RewardSlot(this);
              copy._slotItems = copy._slotItems.concat([RewardItem.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._slotItems.length === 0) {
                return this;
              }
              const copy = new RewardSlot(this);
              copy._slotItems = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._slotItems.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new RewardSlot(this);
              copy._slotItems = copy._slotItems.slice();
              copy._slotItems[path[1]] = RewardItem.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new RewardSlot(this);
              copy._slotItems = copy._slotItems.slice(0, path[1]).concat(copy._slotItems.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._slotItems.length) {
            return this;
          }
          const oldValue = this._slotItems[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new RewardSlot(this);
          copy._slotItems = copy._slotItems.slice();
          copy._slotItems[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {RewardSlot} other
   * @returns {RewardSlot}
   */
  merge(other) {
    const copy = new RewardSlot(this);
    copy._slotItems = this._slotItems.concat(other._slotItems);
    return copy;
  }
}
RewardSlot.default = new RewardSlot();
class RewardSlot_Builder {
  constructor(value) {
    this._value = new RewardSlot(value);
  }
  build() {
    return new RewardSlot(this._value);
  }
  addAllSlotItems(values) {
    this._value._slotItems = this._value._slotItems.concat(values);
    return this;
  }
  addSlotItems(value) {
    this._value._slotItems = this._value._slotItems.concat([value]);
    return this;
  }
  setSlotItems(index, value) {
    this._value._slotItems = this._value._slotItems.concat();
    this._value._slotItems[index] = value;
    return this;
  }
  clearSlotItems() {
    this._value._slotItems = [];
    return this;
  }
}
RewardSlot.Builder = RewardSlot_Builder;
class RewardSlot_WithParent {
  /**
   * @param {RewardSlot} value
   * @param {RewardSlot_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return RewardSlot.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfSlotItems() {
    if (!this._selfSlotItems) {
      this._selfSlotItems = [];
      for (let i of this._value.slotItems) {
        this._selfSlotItems.push(new RewardItem.WithParent(i, null));
      }
    }
    return this._selfSlotItems;
  }
  get inherentSlotItems() {
    if (!this._inherentSlotItems) {
      this._inherentSlotItems = this._parent ? this._parent.slotItems : [];
    }
    return this._inherentSlotItems;
  }
  get slotItems() {
    if (!this._allSlotItems) {
      this._allSlotItems = this._parent ? this._parent.slotItems.concat(this.selfSlotItems) : this.selfSlotItems;
    }
    return this._allSlotItems;
  }
  update(current, parent) {
    const result = new RewardSlot_WithParent(current, parent);
    if (this._selfSlotItems) {
      if (this._value.slotItems === current.slotItems) {
        result._selfSlotItems = this._selfSlotItems;
      } else {
        result._selfSlotItems = [];
        for (let i = 0; i < current.slotItems.length; i++) {
          const oldValue = this._value.slotItems[i];
          if (oldValue) {
            const oldCache = this._selfSlotItems[i];
            if (oldValue === current.slotItems[i]) {
              result._selfSlotItems[i] = oldCache;
            } else {
              result._selfSlotItems[i] = oldCache.update(current.slotItems[i], null);
            }
          } else {
            result._selfSlotItems[i] = new RewardItem.WithParent(current.slotItems[i], null);
          }
        }
      }
    }
    return result;
  }
}
RewardSlot_WithParent.default = new RewardSlot_WithParent(RewardSlot.default, null);
RewardSlot.WithParent = RewardSlot_WithParent;
class RewardSlot_Descriptor {
  get slotItems() {
    if (!this._slotItems) {
      this._slotItems = {
        name: "slotItems",
        Name: "SlotItems",
        number: 2,
        protoType: 11,
        protoName: "slot_items",
        type: RewardItem,
        isRepeated: true,
        options: {
          comments: "The chance field is treated as weight in this group",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._slotItems;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.slotItems,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
RewardSlot.descriptor = new RewardSlot_Descriptor();
export class DungeonRewardPattern {
  get descriptor() {
    return DungeonRewardPattern.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasPatternName = false;
    this._patternName = null;
    this._items = [];
    this._slots = [];
    this._hasFeatured = false;
    this._featured = null;
  }
  isEmpty() {
    if (this._hasPatternName) return false;
    if (this._items.length > 0) return false;
    if (this._slots.length > 0) return false;
    if (this._hasFeatured) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DungeonRewardPattern) {
      return value;
    }
    return DungeonRewardPattern.fromJson(value);
  }
  static fromJson(json) {
    const result = new DungeonRewardPattern();
    if (json.patternName != null) {
      result._hasPatternName = true;
      result._patternName = JsonToString.fromJson(json.patternName);
    }
    result._items = JsonToList(json.items, RewardItem);
    result._slots = JsonToList(json.slots, RewardSlot);
    if (json.featured != null) {
      result._hasFeatured = true;
      result._featured = JsonToBoolean.fromJson(json.featured);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasPatternName) {
      result.patternName = JsonToString.toJson(this._patternName);
    }
    if (this._items.length > 0) {
      result.items = ArrayToJson(this._items, RewardItem);
    }
    if (this._slots.length > 0) {
      result.slots = ArrayToJson(this._slots, RewardSlot);
    }
    if (this._hasFeatured) {
      result.featured = JsonToBoolean.toJson(this._featured);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get patternName() {
    return this._hasPatternName ? this._patternName : JsonToString.default;
  }
  get hasPatternName() {
    return this._hasPatternName;
  }
  setPatternName(path, value) {
    return {type: 'SET', path: path.concat(['patternName']), value};
  }
  deletePatternName(path) {
    return {type: 'DELETE', path: path.concat(['patternName'])};
  }
  /**
   * @returns {RewardItem[]}
   */
  get items() {
    return this._items;
  }
  addItems(path, value) {
    return {type: 'ADD', path: path.concat(['items']), value: value.toJson()};
  }
  setItems(path, value) {
    return {type: 'SET', path: path.concat(['items']), value: ArrayToJson(value, RewardItem)};
  }
  setItemsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['items', key]), value: value.toJson()};
  }
  deleteItems(path) {
    return {type: 'DELETE', path: path.concat(['items'])};
  }
  deleteItemsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['items', key])};
  }
  /**
   * @returns {RewardSlot[]}
   */
  get slots() {
    return this._slots;
  }
  addSlots(path, value) {
    return {type: 'ADD', path: path.concat(['slots']), value: value.toJson()};
  }
  setSlots(path, value) {
    return {type: 'SET', path: path.concat(['slots']), value: ArrayToJson(value, RewardSlot)};
  }
  setSlotsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['slots', key]), value: value.toJson()};
  }
  deleteSlots(path) {
    return {type: 'DELETE', path: path.concat(['slots'])};
  }
  deleteSlotsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['slots', key])};
  }
  /**
   * @returns {boolean}
   */
  get featured() {
    return this._hasFeatured ? this._featured : JsonToBoolean.default;
  }
  get hasFeatured() {
    return this._hasFeatured;
  }
  setFeatured(path, value) {
    return {type: 'SET', path: path.concat(['featured']), value};
  }
  deleteFeatured(path) {
    return {type: 'DELETE', path: path.concat(['featured'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "patternName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DungeonRewardPattern(this);
              copy._hasPatternName = true;
              copy._patternName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPatternName) {
                return this;
              }
              const copy = new DungeonRewardPattern(this);
              copy._hasPatternName = false;
              copy._patternName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "items": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DungeonRewardPattern(this);
              copy._items = [];        for (let i of value) {
                copy._items.push(RewardItem.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new DungeonRewardPattern(this);
              copy._items = copy._items.concat([RewardItem.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._items.length === 0) {
                return this;
              }
              const copy = new DungeonRewardPattern(this);
              copy._items = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._items.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new DungeonRewardPattern(this);
              copy._items = copy._items.slice();
              copy._items[path[1]] = RewardItem.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new DungeonRewardPattern(this);
              copy._items = copy._items.slice(0, path[1]).concat(copy._items.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._items.length) {
            return this;
          }
          const oldValue = this._items[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DungeonRewardPattern(this);
          copy._items = copy._items.slice();
          copy._items[key] = newValue;
          return copy;
        }
      }
      case "slots": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DungeonRewardPattern(this);
              copy._slots = [];        for (let i of value) {
                copy._slots.push(RewardSlot.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new DungeonRewardPattern(this);
              copy._slots = copy._slots.concat([RewardSlot.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._slots.length === 0) {
                return this;
              }
              const copy = new DungeonRewardPattern(this);
              copy._slots = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._slots.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new DungeonRewardPattern(this);
              copy._slots = copy._slots.slice();
              copy._slots[path[1]] = RewardSlot.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new DungeonRewardPattern(this);
              copy._slots = copy._slots.slice(0, path[1]).concat(copy._slots.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._slots.length) {
            return this;
          }
          const oldValue = this._slots[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DungeonRewardPattern(this);
          copy._slots = copy._slots.slice();
          copy._slots[key] = newValue;
          return copy;
        }
      }
      case "featured": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DungeonRewardPattern(this);
              copy._hasFeatured = true;
              copy._featured = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFeatured) {
                return this;
              }
              const copy = new DungeonRewardPattern(this);
              copy._hasFeatured = false;
              copy._featured = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DungeonRewardPattern} other
   * @returns {DungeonRewardPattern}
   */
  merge(other) {
    const copy = new DungeonRewardPattern(this);
    if (other._hasPatternName) {
      copy._hasPatternName = true;
      copy._patternName = other._patternName;
    }
    copy._items = this._items.concat(other._items);
    copy._slots = this._slots.concat(other._slots);
    if (other._hasFeatured) {
      copy._hasFeatured = true;
      copy._featured = other._featured;
    }
    return copy;
  }
}
DungeonRewardPattern.default = new DungeonRewardPattern();
class DungeonRewardPattern_Builder {
  constructor(value) {
    this._value = new DungeonRewardPattern(value);
  }
  build() {
    return new DungeonRewardPattern(this._value);
  }
  setPatternName(value) {
    this._value._hasPatternName = true;
    this._value._patternName = value;
    return this;
  }
  deletePatternName() {
    this._value._hasPatternName = false;
    this._value._patternName = null;
    return this;
  }
  addAllItems(values) {
    this._value._items = this._value._items.concat(values);
    return this;
  }
  addItems(value) {
    this._value._items = this._value._items.concat([value]);
    return this;
  }
  setItems(index, value) {
    this._value._items = this._value._items.concat();
    this._value._items[index] = value;
    return this;
  }
  clearItems() {
    this._value._items = [];
    return this;
  }
  addAllSlots(values) {
    this._value._slots = this._value._slots.concat(values);
    return this;
  }
  addSlots(value) {
    this._value._slots = this._value._slots.concat([value]);
    return this;
  }
  setSlots(index, value) {
    this._value._slots = this._value._slots.concat();
    this._value._slots[index] = value;
    return this;
  }
  clearSlots() {
    this._value._slots = [];
    return this;
  }
  setFeatured(value) {
    this._value._hasFeatured = true;
    this._value._featured = value;
    return this;
  }
  deleteFeatured() {
    this._value._hasFeatured = false;
    this._value._featured = null;
    return this;
  }
}
DungeonRewardPattern.Builder = DungeonRewardPattern_Builder;
class DungeonRewardPattern_WithParent {
  /**
   * @param {DungeonRewardPattern} value
   * @param {DungeonRewardPattern_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DungeonRewardPattern.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasPatternName() {
    if (this._cachedHasPatternName === undefined) {
      if (this._value.hasPatternName) {
        this._cachedHasPatternName = true;
      } else {
        this._cachedHasPatternName = this._parent ? this._parent.hasPatternName : false;
      }
    }
    return this._cachedHasPatternName;
  }
  get patternName() {
    if (this._cachedPatternName === undefined) {
      if (this._value.hasPatternName) {
        this._cachedPatternName = this._value.patternName;
      } else {
        this._cachedPatternName = this._parent ? this._parent.patternName : this._value.patternName;
      }
    }
    return this._cachedPatternName;
  }
  get selfItems() {
    if (!this._selfItems) {
      this._selfItems = [];
      for (let i of this._value.items) {
        this._selfItems.push(new RewardItem.WithParent(i, null));
      }
    }
    return this._selfItems;
  }
  get inherentItems() {
    if (!this._inherentItems) {
      this._inherentItems = this._parent ? this._parent.items : [];
    }
    return this._inherentItems;
  }
  get items() {
    if (!this._allItems) {
      this._allItems = this._parent ? this._parent.items.concat(this.selfItems) : this.selfItems;
    }
    return this._allItems;
  }
  get selfSlots() {
    if (!this._selfSlots) {
      this._selfSlots = [];
      for (let i of this._value.slots) {
        this._selfSlots.push(new RewardSlot.WithParent(i, null));
      }
    }
    return this._selfSlots;
  }
  get inherentSlots() {
    if (!this._inherentSlots) {
      this._inherentSlots = this._parent ? this._parent.slots : [];
    }
    return this._inherentSlots;
  }
  get slots() {
    if (!this._allSlots) {
      this._allSlots = this._parent ? this._parent.slots.concat(this.selfSlots) : this.selfSlots;
    }
    return this._allSlots;
  }
  get hasFeatured() {
    if (this._cachedHasFeatured === undefined) {
      if (this._value.hasFeatured) {
        this._cachedHasFeatured = true;
      } else {
        this._cachedHasFeatured = this._parent ? this._parent.hasFeatured : false;
      }
    }
    return this._cachedHasFeatured;
  }
  get featured() {
    if (this._cachedFeatured === undefined) {
      if (this._value.hasFeatured) {
        this._cachedFeatured = this._value.featured;
      } else {
        this._cachedFeatured = this._parent ? this._parent.featured : this._value.featured;
      }
    }
    return this._cachedFeatured;
  }
  update(current, parent) {
    const result = new DungeonRewardPattern_WithParent(current, parent);
    if (this._selfItems) {
      if (this._value.items === current.items) {
        result._selfItems = this._selfItems;
      } else {
        result._selfItems = [];
        for (let i = 0; i < current.items.length; i++) {
          const oldValue = this._value.items[i];
          if (oldValue) {
            const oldCache = this._selfItems[i];
            if (oldValue === current.items[i]) {
              result._selfItems[i] = oldCache;
            } else {
              result._selfItems[i] = oldCache.update(current.items[i], null);
            }
          } else {
            result._selfItems[i] = new RewardItem.WithParent(current.items[i], null);
          }
        }
      }
    }
    if (this._selfSlots) {
      if (this._value.slots === current.slots) {
        result._selfSlots = this._selfSlots;
      } else {
        result._selfSlots = [];
        for (let i = 0; i < current.slots.length; i++) {
          const oldValue = this._value.slots[i];
          if (oldValue) {
            const oldCache = this._selfSlots[i];
            if (oldValue === current.slots[i]) {
              result._selfSlots[i] = oldCache;
            } else {
              result._selfSlots[i] = oldCache.update(current.slots[i], null);
            }
          } else {
            result._selfSlots[i] = new RewardSlot.WithParent(current.slots[i], null);
          }
        }
      }
    }
    return result;
  }
}
DungeonRewardPattern_WithParent.default = new DungeonRewardPattern_WithParent(DungeonRewardPattern.default, null);
DungeonRewardPattern.WithParent = DungeonRewardPattern_WithParent;
class DungeonRewardPattern_Descriptor {
  get patternName() {
    if (!this._patternName) {
      this._patternName = {
        name: "patternName",
        Name: "PatternName",
        number: 1,
        protoType: 9,
        protoName: "pattern_name",
        type: JsonToString,
        options: {
          comments: "This MUST be unique among all patterns",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._patternName;
  }
  get items() {
    if (!this._items) {
      this._items = {
        name: "items",
        Name: "Items",
        number: 2,
        protoType: 11,
        protoName: "items",
        type: RewardItem,
        isRepeated: true,
        options: {
          comments: "This means the chance field will roll on its own for all items",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._items;
  }
  get slots() {
    if (!this._slots) {
      this._slots = {
        name: "slots",
        Name: "Slots",
        number: 3,
        protoType: 11,
        protoName: "slots",
        type: RewardSlot,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._slots;
  }
  get featured() {
    if (!this._featured) {
      this._featured = {
        name: "featured",
        Name: "Featured",
        number: 4,
        protoType: 8,
        protoName: "featured",
        type: JsonToBoolean,
        options: {
          comments: "Whether this pattern is only used as membership extra reward",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._featured;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.patternName,
        this.items,
        this.slots,
        this.featured,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForPatternName",
        Name: "DummyOneofForPatternName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFeatured",
        Name: "DummyOneofForFeatured",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
DungeonRewardPattern.descriptor = new DungeonRewardPattern_Descriptor();
export class ElementalTrialDungeon {
  get descriptor() {
    return ElementalTrialDungeon.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._dungeons = [];
    this._hasDailyRefreshTime = false;
    this._dailyRefreshTime = null;
    this._hasDefaultPlayCount = false;
    this._defaultPlayCount = null;
    this._extraPurchaseCosts = [];
  }
  isEmpty() {
    if (this._dungeons.length > 0) return false;
    if (this._hasDailyRefreshTime) return false;
    if (this._hasDefaultPlayCount) return false;
    if (this._extraPurchaseCosts.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ElementalTrialDungeon) {
      return value;
    }
    return ElementalTrialDungeon.fromJson(value);
  }
  static fromJson(json) {
    const result = new ElementalTrialDungeon();
    result._dungeons = JsonToList(json.dungeons, Dungeon);
    if (json.dailyRefreshTime != null) {
      result._hasDailyRefreshTime = true;
      result._dailyRefreshTime = JsonToInt32.fromJson(json.dailyRefreshTime);
    }
    if (json.defaultPlayCount != null) {
      result._hasDefaultPlayCount = true;
      result._defaultPlayCount = JsonToInt32.fromJson(json.defaultPlayCount);
    }
    result._extraPurchaseCosts = JsonToList(json.extraPurchaseCosts, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._dungeons.length > 0) {
      result.dungeons = ArrayToJson(this._dungeons, Dungeon);
    }
    if (this._hasDailyRefreshTime) {
      result.dailyRefreshTime = JsonToInt32.toJson(this._dailyRefreshTime);
    }
    if (this._hasDefaultPlayCount) {
      result.defaultPlayCount = JsonToInt32.toJson(this._defaultPlayCount);
    }
    if (this._extraPurchaseCosts.length > 0) {
      result.extraPurchaseCosts = ArrayToJson(this._extraPurchaseCosts, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    }
    return result;
  }
  /**
   * @returns {Dungeon[]}
   */
  get dungeons() {
    return this._dungeons;
  }
  addDungeons(path, value) {
    return {type: 'ADD', path: path.concat(['dungeons']), value: value.toJson()};
  }
  setDungeons(path, value) {
    return {type: 'SET', path: path.concat(['dungeons']), value: ArrayToJson(value, Dungeon)};
  }
  setDungeonsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['dungeons', key]), value: value.toJson()};
  }
  deleteDungeons(path) {
    return {type: 'DELETE', path: path.concat(['dungeons'])};
  }
  deleteDungeonsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['dungeons', key])};
  }
  /**
   * @returns {number}
   */
  get dailyRefreshTime() {
    return this._hasDailyRefreshTime ? this._dailyRefreshTime : JsonToInt32.default;
  }
  get hasDailyRefreshTime() {
    return this._hasDailyRefreshTime;
  }
  setDailyRefreshTime(path, value) {
    return {type: 'SET', path: path.concat(['dailyRefreshTime']), value};
  }
  deleteDailyRefreshTime(path) {
    return {type: 'DELETE', path: path.concat(['dailyRefreshTime'])};
  }
  /**
   * @returns {number}
   */
  get defaultPlayCount() {
    return this._hasDefaultPlayCount ? this._defaultPlayCount : JsonToInt32.default;
  }
  get hasDefaultPlayCount() {
    return this._hasDefaultPlayCount;
  }
  setDefaultPlayCount(path, value) {
    return {type: 'SET', path: path.concat(['defaultPlayCount']), value};
  }
  deleteDefaultPlayCount(path) {
    return {type: 'DELETE', path: path.concat(['defaultPlayCount'])};
  }
  /**
   * @returns {dcei_wildsky_common_proto.InventoryItemKeyValuePair[]}
   */
  get extraPurchaseCosts() {
    return this._extraPurchaseCosts;
  }
  addExtraPurchaseCosts(path, value) {
    return {type: 'ADD', path: path.concat(['extraPurchaseCosts']), value: value.toJson()};
  }
  setExtraPurchaseCosts(path, value) {
    return {type: 'SET', path: path.concat(['extraPurchaseCosts']), value: ArrayToJson(value, dcei_wildsky_common_proto.InventoryItemKeyValuePair)};
  }
  setExtraPurchaseCostsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['extraPurchaseCosts', key]), value: value.toJson()};
  }
  deleteExtraPurchaseCosts(path) {
    return {type: 'DELETE', path: path.concat(['extraPurchaseCosts'])};
  }
  deleteExtraPurchaseCostsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['extraPurchaseCosts', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "dungeons": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ElementalTrialDungeon(this);
              copy._dungeons = [];        for (let i of value) {
                copy._dungeons.push(Dungeon.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ElementalTrialDungeon(this);
              copy._dungeons = copy._dungeons.concat([Dungeon.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._dungeons.length === 0) {
                return this;
              }
              const copy = new ElementalTrialDungeon(this);
              copy._dungeons = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._dungeons.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ElementalTrialDungeon(this);
              copy._dungeons = copy._dungeons.slice();
              copy._dungeons[path[1]] = Dungeon.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ElementalTrialDungeon(this);
              copy._dungeons = copy._dungeons.slice(0, path[1]).concat(copy._dungeons.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._dungeons.length) {
            return this;
          }
          const oldValue = this._dungeons[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ElementalTrialDungeon(this);
          copy._dungeons = copy._dungeons.slice();
          copy._dungeons[key] = newValue;
          return copy;
        }
      }
      case "dailyRefreshTime": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ElementalTrialDungeon(this);
              copy._hasDailyRefreshTime = true;
              copy._dailyRefreshTime = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDailyRefreshTime) {
                return this;
              }
              const copy = new ElementalTrialDungeon(this);
              copy._hasDailyRefreshTime = false;
              copy._dailyRefreshTime = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "defaultPlayCount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ElementalTrialDungeon(this);
              copy._hasDefaultPlayCount = true;
              copy._defaultPlayCount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDefaultPlayCount) {
                return this;
              }
              const copy = new ElementalTrialDungeon(this);
              copy._hasDefaultPlayCount = false;
              copy._defaultPlayCount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "extraPurchaseCosts": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ElementalTrialDungeon(this);
              copy._extraPurchaseCosts = [];        for (let i of value) {
                copy._extraPurchaseCosts.push(dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ElementalTrialDungeon(this);
              copy._extraPurchaseCosts = copy._extraPurchaseCosts.concat([dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._extraPurchaseCosts.length === 0) {
                return this;
              }
              const copy = new ElementalTrialDungeon(this);
              copy._extraPurchaseCosts = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._extraPurchaseCosts.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ElementalTrialDungeon(this);
              copy._extraPurchaseCosts = copy._extraPurchaseCosts.slice();
              copy._extraPurchaseCosts[path[1]] = dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ElementalTrialDungeon(this);
              copy._extraPurchaseCosts = copy._extraPurchaseCosts.slice(0, path[1]).concat(copy._extraPurchaseCosts.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._extraPurchaseCosts.length) {
            return this;
          }
          const oldValue = this._extraPurchaseCosts[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ElementalTrialDungeon(this);
          copy._extraPurchaseCosts = copy._extraPurchaseCosts.slice();
          copy._extraPurchaseCosts[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ElementalTrialDungeon} other
   * @returns {ElementalTrialDungeon}
   */
  merge(other) {
    const copy = new ElementalTrialDungeon(this);
    copy._dungeons = this._dungeons.concat(other._dungeons);
    if (other._hasDailyRefreshTime) {
      copy._hasDailyRefreshTime = true;
      copy._dailyRefreshTime = other._dailyRefreshTime;
    }
    if (other._hasDefaultPlayCount) {
      copy._hasDefaultPlayCount = true;
      copy._defaultPlayCount = other._defaultPlayCount;
    }
    copy._extraPurchaseCosts = this._extraPurchaseCosts.concat(other._extraPurchaseCosts);
    return copy;
  }
}
ElementalTrialDungeon.default = new ElementalTrialDungeon();
class ElementalTrialDungeon_Builder {
  constructor(value) {
    this._value = new ElementalTrialDungeon(value);
  }
  build() {
    return new ElementalTrialDungeon(this._value);
  }
  addAllDungeons(values) {
    this._value._dungeons = this._value._dungeons.concat(values);
    return this;
  }
  addDungeons(value) {
    this._value._dungeons = this._value._dungeons.concat([value]);
    return this;
  }
  setDungeons(index, value) {
    this._value._dungeons = this._value._dungeons.concat();
    this._value._dungeons[index] = value;
    return this;
  }
  clearDungeons() {
    this._value._dungeons = [];
    return this;
  }
  setDailyRefreshTime(value) {
    this._value._hasDailyRefreshTime = true;
    this._value._dailyRefreshTime = value;
    return this;
  }
  deleteDailyRefreshTime() {
    this._value._hasDailyRefreshTime = false;
    this._value._dailyRefreshTime = null;
    return this;
  }
  setDefaultPlayCount(value) {
    this._value._hasDefaultPlayCount = true;
    this._value._defaultPlayCount = value;
    return this;
  }
  deleteDefaultPlayCount() {
    this._value._hasDefaultPlayCount = false;
    this._value._defaultPlayCount = null;
    return this;
  }
  addAllExtraPurchaseCosts(values) {
    this._value._extraPurchaseCosts = this._value._extraPurchaseCosts.concat(values);
    return this;
  }
  addExtraPurchaseCosts(value) {
    this._value._extraPurchaseCosts = this._value._extraPurchaseCosts.concat([value]);
    return this;
  }
  setExtraPurchaseCosts(index, value) {
    this._value._extraPurchaseCosts = this._value._extraPurchaseCosts.concat();
    this._value._extraPurchaseCosts[index] = value;
    return this;
  }
  clearExtraPurchaseCosts() {
    this._value._extraPurchaseCosts = [];
    return this;
  }
}
ElementalTrialDungeon.Builder = ElementalTrialDungeon_Builder;
class ElementalTrialDungeon_WithParent {
  /**
   * @param {ElementalTrialDungeon} value
   * @param {ElementalTrialDungeon_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ElementalTrialDungeon.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfDungeons() {
    if (!this._selfDungeons) {
      this._selfDungeons = [];
      for (let i of this._value.dungeons) {
        this._selfDungeons.push(new Dungeon.WithParent(i, null));
      }
    }
    return this._selfDungeons;
  }
  get inherentDungeons() {
    if (!this._inherentDungeons) {
      this._inherentDungeons = this._parent ? this._parent.dungeons : [];
    }
    return this._inherentDungeons;
  }
  get dungeons() {
    if (!this._allDungeons) {
      this._allDungeons = this._parent ? this._parent.dungeons.concat(this.selfDungeons) : this.selfDungeons;
    }
    return this._allDungeons;
  }
  get hasDailyRefreshTime() {
    if (this._cachedHasDailyRefreshTime === undefined) {
      if (this._value.hasDailyRefreshTime) {
        this._cachedHasDailyRefreshTime = true;
      } else {
        this._cachedHasDailyRefreshTime = this._parent ? this._parent.hasDailyRefreshTime : false;
      }
    }
    return this._cachedHasDailyRefreshTime;
  }
  get dailyRefreshTime() {
    if (this._cachedDailyRefreshTime === undefined) {
      if (this._value.hasDailyRefreshTime) {
        this._cachedDailyRefreshTime = this._value.dailyRefreshTime;
      } else {
        this._cachedDailyRefreshTime = this._parent ? this._parent.dailyRefreshTime : this._value.dailyRefreshTime;
      }
    }
    return this._cachedDailyRefreshTime;
  }
  get hasDefaultPlayCount() {
    if (this._cachedHasDefaultPlayCount === undefined) {
      if (this._value.hasDefaultPlayCount) {
        this._cachedHasDefaultPlayCount = true;
      } else {
        this._cachedHasDefaultPlayCount = this._parent ? this._parent.hasDefaultPlayCount : false;
      }
    }
    return this._cachedHasDefaultPlayCount;
  }
  get defaultPlayCount() {
    if (this._cachedDefaultPlayCount === undefined) {
      if (this._value.hasDefaultPlayCount) {
        this._cachedDefaultPlayCount = this._value.defaultPlayCount;
      } else {
        this._cachedDefaultPlayCount = this._parent ? this._parent.defaultPlayCount : this._value.defaultPlayCount;
      }
    }
    return this._cachedDefaultPlayCount;
  }
  get selfExtraPurchaseCosts() {
    if (!this._selfExtraPurchaseCosts) {
      this._selfExtraPurchaseCosts = [];
      for (let i of this._value.extraPurchaseCosts) {
        this._selfExtraPurchaseCosts.push(new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(i, null));
      }
    }
    return this._selfExtraPurchaseCosts;
  }
  get inherentExtraPurchaseCosts() {
    if (!this._inherentExtraPurchaseCosts) {
      this._inherentExtraPurchaseCosts = this._parent ? this._parent.extraPurchaseCosts : [];
    }
    return this._inherentExtraPurchaseCosts;
  }
  get extraPurchaseCosts() {
    if (!this._allExtraPurchaseCosts) {
      this._allExtraPurchaseCosts = this._parent ? this._parent.extraPurchaseCosts.concat(this.selfExtraPurchaseCosts) : this.selfExtraPurchaseCosts;
    }
    return this._allExtraPurchaseCosts;
  }
  update(current, parent) {
    const result = new ElementalTrialDungeon_WithParent(current, parent);
    if (this._selfDungeons) {
      if (this._value.dungeons === current.dungeons) {
        result._selfDungeons = this._selfDungeons;
      } else {
        result._selfDungeons = [];
        for (let i = 0; i < current.dungeons.length; i++) {
          const oldValue = this._value.dungeons[i];
          if (oldValue) {
            const oldCache = this._selfDungeons[i];
            if (oldValue === current.dungeons[i]) {
              result._selfDungeons[i] = oldCache;
            } else {
              result._selfDungeons[i] = oldCache.update(current.dungeons[i], null);
            }
          } else {
            result._selfDungeons[i] = new Dungeon.WithParent(current.dungeons[i], null);
          }
        }
      }
    }
    if (this._selfExtraPurchaseCosts) {
      if (this._value.extraPurchaseCosts === current.extraPurchaseCosts) {
        result._selfExtraPurchaseCosts = this._selfExtraPurchaseCosts;
      } else {
        result._selfExtraPurchaseCosts = [];
        for (let i = 0; i < current.extraPurchaseCosts.length; i++) {
          const oldValue = this._value.extraPurchaseCosts[i];
          if (oldValue) {
            const oldCache = this._selfExtraPurchaseCosts[i];
            if (oldValue === current.extraPurchaseCosts[i]) {
              result._selfExtraPurchaseCosts[i] = oldCache;
            } else {
              result._selfExtraPurchaseCosts[i] = oldCache.update(current.extraPurchaseCosts[i], null);
            }
          } else {
            result._selfExtraPurchaseCosts[i] = new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(current.extraPurchaseCosts[i], null);
          }
        }
      }
    }
    return result;
  }
}
ElementalTrialDungeon_WithParent.default = new ElementalTrialDungeon_WithParent(ElementalTrialDungeon.default, null);
ElementalTrialDungeon.WithParent = ElementalTrialDungeon_WithParent;
class ElementalTrialDungeon_Descriptor {
  get dungeons() {
    if (!this._dungeons) {
      this._dungeons = {
        name: "dungeons",
        Name: "Dungeons",
        number: 1,
        protoType: 11,
        protoName: "dungeons",
        type: Dungeon,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dungeons;
  }
  get dailyRefreshTime() {
    if (!this._dailyRefreshTime) {
      this._dailyRefreshTime = {
        name: "dailyRefreshTime",
        Name: "DailyRefreshTime",
        number: 2,
        protoType: 5,
        protoName: "daily_refresh_time",
        type: JsonToInt32,
        options: {
          comments: "Time in seconds passed from midnight",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dailyRefreshTime;
  }
  get defaultPlayCount() {
    if (!this._defaultPlayCount) {
      this._defaultPlayCount = {
        name: "defaultPlayCount",
        Name: "DefaultPlayCount",
        number: 3,
        protoType: 5,
        protoName: "default_play_count",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._defaultPlayCount;
  }
  get extraPurchaseCosts() {
    if (!this._extraPurchaseCosts) {
      this._extraPurchaseCosts = {
        name: "extraPurchaseCosts",
        Name: "ExtraPurchaseCosts",
        number: 6,
        protoType: 11,
        protoName: "extra_purchase_costs",
        type: dcei_wildsky_common_proto.InventoryItemKeyValuePair,
        isRepeated: true,
        options: {
          comments: "string extra_purchase_currency_key = 4; int32 extra_purchase_cost = 5;",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._extraPurchaseCosts;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.dungeons,
        this.dailyRefreshTime,
        this.defaultPlayCount,
        this.extraPurchaseCosts,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDailyRefreshTime",
        Name: "DummyOneofForDailyRefreshTime",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDefaultPlayCount",
        Name: "DummyOneofForDefaultPlayCount",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
ElementalTrialDungeon.descriptor = new ElementalTrialDungeon_Descriptor();
export class DungeonRewardPatterns {
  get descriptor() {
    return DungeonRewardPatterns.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._rewardPatterns = [];
  }
  isEmpty() {
    if (this._rewardPatterns.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DungeonRewardPatterns) {
      return value;
    }
    return DungeonRewardPatterns.fromJson(value);
  }
  static fromJson(json) {
    const result = new DungeonRewardPatterns();
    result._rewardPatterns = JsonToList(json.rewardPatterns, DungeonRewardPattern);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._rewardPatterns.length > 0) {
      result.rewardPatterns = ArrayToJson(this._rewardPatterns, DungeonRewardPattern);
    }
    return result;
  }
  /**
   * @returns {DungeonRewardPattern[]}
   */
  get rewardPatterns() {
    return this._rewardPatterns;
  }
  addRewardPatterns(path, value) {
    return {type: 'ADD', path: path.concat(['rewardPatterns']), value: value.toJson()};
  }
  setRewardPatterns(path, value) {
    return {type: 'SET', path: path.concat(['rewardPatterns']), value: ArrayToJson(value, DungeonRewardPattern)};
  }
  setRewardPatternsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['rewardPatterns', key]), value: value.toJson()};
  }
  deleteRewardPatterns(path) {
    return {type: 'DELETE', path: path.concat(['rewardPatterns'])};
  }
  deleteRewardPatternsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['rewardPatterns', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "rewardPatterns": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DungeonRewardPatterns(this);
              copy._rewardPatterns = [];        for (let i of value) {
                copy._rewardPatterns.push(DungeonRewardPattern.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new DungeonRewardPatterns(this);
              copy._rewardPatterns = copy._rewardPatterns.concat([DungeonRewardPattern.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._rewardPatterns.length === 0) {
                return this;
              }
              const copy = new DungeonRewardPatterns(this);
              copy._rewardPatterns = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._rewardPatterns.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new DungeonRewardPatterns(this);
              copy._rewardPatterns = copy._rewardPatterns.slice();
              copy._rewardPatterns[path[1]] = DungeonRewardPattern.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new DungeonRewardPatterns(this);
              copy._rewardPatterns = copy._rewardPatterns.slice(0, path[1]).concat(copy._rewardPatterns.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._rewardPatterns.length) {
            return this;
          }
          const oldValue = this._rewardPatterns[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DungeonRewardPatterns(this);
          copy._rewardPatterns = copy._rewardPatterns.slice();
          copy._rewardPatterns[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DungeonRewardPatterns} other
   * @returns {DungeonRewardPatterns}
   */
  merge(other) {
    const copy = new DungeonRewardPatterns(this);
    copy._rewardPatterns = this._rewardPatterns.concat(other._rewardPatterns);
    return copy;
  }
}
DungeonRewardPatterns.default = new DungeonRewardPatterns();
class DungeonRewardPatterns_Builder {
  constructor(value) {
    this._value = new DungeonRewardPatterns(value);
  }
  build() {
    return new DungeonRewardPatterns(this._value);
  }
  addAllRewardPatterns(values) {
    this._value._rewardPatterns = this._value._rewardPatterns.concat(values);
    return this;
  }
  addRewardPatterns(value) {
    this._value._rewardPatterns = this._value._rewardPatterns.concat([value]);
    return this;
  }
  setRewardPatterns(index, value) {
    this._value._rewardPatterns = this._value._rewardPatterns.concat();
    this._value._rewardPatterns[index] = value;
    return this;
  }
  clearRewardPatterns() {
    this._value._rewardPatterns = [];
    return this;
  }
}
DungeonRewardPatterns.Builder = DungeonRewardPatterns_Builder;
class DungeonRewardPatterns_WithParent {
  /**
   * @param {DungeonRewardPatterns} value
   * @param {DungeonRewardPatterns_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DungeonRewardPatterns.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfRewardPatterns() {
    if (!this._selfRewardPatterns) {
      this._selfRewardPatterns = [];
      for (let i of this._value.rewardPatterns) {
        this._selfRewardPatterns.push(new DungeonRewardPattern.WithParent(i, null));
      }
    }
    return this._selfRewardPatterns;
  }
  get inherentRewardPatterns() {
    if (!this._inherentRewardPatterns) {
      this._inherentRewardPatterns = this._parent ? this._parent.rewardPatterns : [];
    }
    return this._inherentRewardPatterns;
  }
  get rewardPatterns() {
    if (!this._allRewardPatterns) {
      this._allRewardPatterns = this._parent ? this._parent.rewardPatterns.concat(this.selfRewardPatterns) : this.selfRewardPatterns;
    }
    return this._allRewardPatterns;
  }
  update(current, parent) {
    const result = new DungeonRewardPatterns_WithParent(current, parent);
    if (this._selfRewardPatterns) {
      if (this._value.rewardPatterns === current.rewardPatterns) {
        result._selfRewardPatterns = this._selfRewardPatterns;
      } else {
        result._selfRewardPatterns = [];
        for (let i = 0; i < current.rewardPatterns.length; i++) {
          const oldValue = this._value.rewardPatterns[i];
          if (oldValue) {
            const oldCache = this._selfRewardPatterns[i];
            if (oldValue === current.rewardPatterns[i]) {
              result._selfRewardPatterns[i] = oldCache;
            } else {
              result._selfRewardPatterns[i] = oldCache.update(current.rewardPatterns[i], null);
            }
          } else {
            result._selfRewardPatterns[i] = new DungeonRewardPattern.WithParent(current.rewardPatterns[i], null);
          }
        }
      }
    }
    return result;
  }
}
DungeonRewardPatterns_WithParent.default = new DungeonRewardPatterns_WithParent(DungeonRewardPatterns.default, null);
DungeonRewardPatterns.WithParent = DungeonRewardPatterns_WithParent;
class DungeonRewardPatterns_Descriptor {
  get rewardPatterns() {
    if (!this._rewardPatterns) {
      this._rewardPatterns = {
        name: "rewardPatterns",
        Name: "RewardPatterns",
        number: 1,
        protoType: 11,
        protoName: "reward_patterns",
        type: DungeonRewardPattern,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rewardPatterns;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.rewardPatterns,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
DungeonRewardPatterns.descriptor = new DungeonRewardPatterns_Descriptor();
export class Dungeons {
  get descriptor() {
    return Dungeons.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasElementalTrial = false;
    this._elementalTrial = null;
    this._hasRewardPatterns = false;
    this._rewardPatterns = null;
  }
  isEmpty() {
    if (this._hasElementalTrial && !this._elementalTrial.isEmpty()) return false;
    if (this._hasRewardPatterns && !this._rewardPatterns.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Dungeons) {
      return value;
    }
    return Dungeons.fromJson(value);
  }
  static fromJson(json) {
    const result = new Dungeons();
    if (json.elementalTrial != null) {
      result._hasElementalTrial = true;
      result._elementalTrial = ElementalTrialDungeon.fromJson(json.elementalTrial);
    }
    if (json.rewardPatterns != null) {
      result._hasRewardPatterns = true;
      result._rewardPatterns = DungeonRewardPatterns.fromJson(json.rewardPatterns);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasElementalTrial && !this._elementalTrial.isEmpty()) {
      result.elementalTrial = ElementalTrialDungeon.toJson(this._elementalTrial);
    }
    if (this._hasRewardPatterns && !this._rewardPatterns.isEmpty()) {
      result.rewardPatterns = DungeonRewardPatterns.toJson(this._rewardPatterns);
    }
    return result;
  }
  /**
   * @returns {ElementalTrialDungeon}
   */
  get elementalTrial() {
    return this._hasElementalTrial ? this._elementalTrial : ElementalTrialDungeon.default;
  }
  get hasElementalTrial() {
    return this._hasElementalTrial;
  }
  setElementalTrial(path, value) {
    return {type: 'SET', path: path.concat(['elementalTrial']), value: value.toJson()};
  }
  deleteElementalTrial(path) {
    return {type: 'DELETE', path: path.concat(['elementalTrial'])};
  }
  /**
   * @returns {DungeonRewardPatterns}
   */
  get rewardPatterns() {
    return this._hasRewardPatterns ? this._rewardPatterns : DungeonRewardPatterns.default;
  }
  get hasRewardPatterns() {
    return this._hasRewardPatterns;
  }
  setRewardPatterns(path, value) {
    return {type: 'SET', path: path.concat(['rewardPatterns']), value: value.toJson()};
  }
  deleteRewardPatterns(path) {
    return {type: 'DELETE', path: path.concat(['rewardPatterns'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "elementalTrial": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Dungeons(this);
              copy._hasElementalTrial = true;
              copy._elementalTrial = ElementalTrialDungeon.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasElementalTrial) {
                return this;
              }
              const copy = new Dungeons(this);
              copy._hasElementalTrial = false;
              copy._elementalTrial = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasElementalTrial) {
            const copy = new Dungeons(this);
            copy._hasElementalTrial = true;
            copy._elementalTrial = ElementalTrialDungeon.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._elementalTrial.apply(type, path.slice(1), value);
          if (newValue === this._elementalTrial) {
            return this;
          }
          const copy = new Dungeons(this);
          copy._elementalTrial = copy._elementalTrial.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "rewardPatterns": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Dungeons(this);
              copy._hasRewardPatterns = true;
              copy._rewardPatterns = DungeonRewardPatterns.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRewardPatterns) {
                return this;
              }
              const copy = new Dungeons(this);
              copy._hasRewardPatterns = false;
              copy._rewardPatterns = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasRewardPatterns) {
            const copy = new Dungeons(this);
            copy._hasRewardPatterns = true;
            copy._rewardPatterns = DungeonRewardPatterns.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._rewardPatterns.apply(type, path.slice(1), value);
          if (newValue === this._rewardPatterns) {
            return this;
          }
          const copy = new Dungeons(this);
          copy._rewardPatterns = copy._rewardPatterns.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Dungeons} other
   * @returns {Dungeons}
   */
  merge(other) {
    const copy = new Dungeons(this);
    if (other._hasElementalTrial) {
      if (copy._hasElementalTrial) {
        copy._elementalTrial = copy.elementalTrial.merge(other.elementalTrial);
      } else {
        copy._elementalTrial = other._elementalTrial;
      }
      copy._hasElementalTrial = true;
    }
    if (other._hasRewardPatterns) {
      if (copy._hasRewardPatterns) {
        copy._rewardPatterns = copy.rewardPatterns.merge(other.rewardPatterns);
      } else {
        copy._rewardPatterns = other._rewardPatterns;
      }
      copy._hasRewardPatterns = true;
    }
    return copy;
  }
}
Dungeons.default = new Dungeons();
class Dungeons_Builder {
  constructor(value) {
    this._value = new Dungeons(value);
  }
  build() {
    return new Dungeons(this._value);
  }
  setElementalTrial(value) {
    this._value._hasElementalTrial = true;
    this._value._elementalTrial = value;
    return this;
  }
  deleteElementalTrial() {
    this._value._hasElementalTrial = false;
    this._value._elementalTrial = null;
    return this;
  }
  setRewardPatterns(value) {
    this._value._hasRewardPatterns = true;
    this._value._rewardPatterns = value;
    return this;
  }
  deleteRewardPatterns() {
    this._value._hasRewardPatterns = false;
    this._value._rewardPatterns = null;
    return this;
  }
}
Dungeons.Builder = Dungeons_Builder;
class Dungeons_WithParent {
  /**
   * @param {Dungeons} value
   * @param {Dungeons_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Dungeons.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasElementalTrial() {
    if (this._cachedHasElementalTrial === undefined) {
      if (this._value.hasElementalTrial) {
        this._cachedHasElementalTrial = true;
      } else {
        this._cachedHasElementalTrial = this._parent ? this._parent.hasElementalTrial : false;
      }
    }
    return this._cachedHasElementalTrial;
  }
  get elementalTrial() {
    if (!this._cachedElementalTrial) {
      if (this._value.hasElementalTrial) {
        this._cachedElementalTrial = new ElementalTrialDungeon.WithParent(this._value.elementalTrial, this._parent && this._parent.hasElementalTrial ? this._parent.elementalTrial : null);
      } else {
        this._cachedElementalTrial = this._parent ? new ElementalTrialDungeon.WithParent(ElementalTrialDungeon.default, this._parent.elementalTrial) : ElementalTrialDungeon.WithParent.default;
      }
    }
    return this._cachedElementalTrial;
  }
  get hasRewardPatterns() {
    if (this._cachedHasRewardPatterns === undefined) {
      if (this._value.hasRewardPatterns) {
        this._cachedHasRewardPatterns = true;
      } else {
        this._cachedHasRewardPatterns = this._parent ? this._parent.hasRewardPatterns : false;
      }
    }
    return this._cachedHasRewardPatterns;
  }
  get rewardPatterns() {
    if (!this._cachedRewardPatterns) {
      if (this._value.hasRewardPatterns) {
        this._cachedRewardPatterns = new DungeonRewardPatterns.WithParent(this._value.rewardPatterns, this._parent && this._parent.hasRewardPatterns ? this._parent.rewardPatterns : null);
      } else {
        this._cachedRewardPatterns = this._parent ? new DungeonRewardPatterns.WithParent(DungeonRewardPatterns.default, this._parent.rewardPatterns) : DungeonRewardPatterns.WithParent.default;
      }
    }
    return this._cachedRewardPatterns;
  }
  update(current, parent) {
    const result = new Dungeons_WithParent(current, parent);
    if (this._cachedElementalTrial && this._value.hasElementalTrial && current.hasElementalTrial) {
      if (this._value.elementalTrial === current.elementalTrial && this._parent === parent) {
        result._cachedElementalTrial = this._cachedElementalTrial;
      } else {
        result._cachedElementalTrial = this._cachedElementalTrial.update(current.elementalTrial, parent && parent.hasElementalTrial ? parent.elementalTrial : null);
      }
    }
    if (this._cachedRewardPatterns && this._value.hasRewardPatterns && current.hasRewardPatterns) {
      if (this._value.rewardPatterns === current.rewardPatterns && this._parent === parent) {
        result._cachedRewardPatterns = this._cachedRewardPatterns;
      } else {
        result._cachedRewardPatterns = this._cachedRewardPatterns.update(current.rewardPatterns, parent && parent.hasRewardPatterns ? parent.rewardPatterns : null);
      }
    }
    return result;
  }
}
Dungeons_WithParent.default = new Dungeons_WithParent(Dungeons.default, null);
Dungeons.WithParent = Dungeons_WithParent;
class Dungeons_Descriptor {
  get elementalTrial() {
    if (!this._elementalTrial) {
      this._elementalTrial = {
        name: "elementalTrial",
        Name: "ElementalTrial",
        number: 1,
        protoType: 11,
        protoName: "elemental_trial",
        type: ElementalTrialDungeon,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._elementalTrial;
  }
  get rewardPatterns() {
    if (!this._rewardPatterns) {
      this._rewardPatterns = {
        name: "rewardPatterns",
        Name: "RewardPatterns",
        number: 3,
        protoType: 11,
        protoName: "reward_patterns",
        type: DungeonRewardPatterns,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rewardPatterns;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.elementalTrial,
        this.rewardPatterns,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForElementalTrial",
        Name: "DummyOneofForElementalTrial",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRewardPatterns",
        Name: "DummyOneofForRewardPatterns",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
Dungeons.descriptor = new Dungeons_Descriptor();
